import * as Surplus from "surplus";
import S from "s-js";

declare global {
    interface Window {
        Surplus: typeof Surplus;
        S: typeof S;
    }
}

const globalScope: any = typeof globalThis !== "undefined" ? globalThis : window;

globalScope.Surplus = Surplus;
globalScope.S = S;

console.log("surplus");
export {};
